import React from "react"
import Image from "./image"
import menuData from "../data/menu.json"
import findObject from "../helpers/find-object"
import { Link } from "gatsby"
import Arrow from "../images/arrow.inline.svg"

export default function SectionEnder({ sectionID, pageID }) {
  const section = findObject(menuData, "id", sectionID)
  const { href, name, part, cover } = section
  const { name: childName, deck } = section.children[0]

  return (
    <Link className="section-ender" to={href}>
      <div className="section-ender__image" role="presentation">
        <Image path={cover} />
      </div>
      <div className="section-ender__content">
        <div className="section-ender__title">
          <h2>{part}</h2>
          <h3>{name}</h3>
        </div>
        <div className="read-next__content">
          <div className="read-next__content__inner">
            <header>
              <h2 className="title title--s title--bold title--uppercase">
                Read Next
              </h2>
              <h3 className="title title--m md:title--l">{childName}</h3>
            </header>
            {deck && <p>{deck}</p>}
          </div>
          <div className="read-next__content__arrow">
            <Arrow />
          </div>
        </div>
      </div>
    </Link>
  )
}
